import { Container } from "@material-ui/core";
import SRCards from "../../components/SRCards";
import { FormControl, InputLabel, Select, MenuItem } from "@material-ui/core";
import { useState } from "react";
import FPFormMigration from "./FPFormMigration";
import { makeStyles } from "@material-ui/core/styles";
import FpFormTemplateId from "../settings/FpFormTemplateId";

const useStyles = makeStyles({
  optionSelect: {
    marginBottom: "40px",
    marginTop: "40px"
  },
});

const FPForms = () => {
  const classes = useStyles();
  const [option, setOption] = useState("");

  const handleChange = async (e: any) => {
    switch (e.target.value) {
      case 1:
        setOption("Migration");
        break;
      case 2:
        setOption("Add template to FP Form");
    }
  };
  return (
    <>
      <SRCards />
      <Container>
        <FormControl fullWidth className={classes.optionSelect}>
          <InputLabel id="demo-simple-select-label">Option</InputLabel>
          <Select onChange={handleChange}>
            <MenuItem value={1}>Migration</MenuItem>
            <MenuItem value={2}>Add template to FP Form</MenuItem>
          </Select>
        </FormControl>
        {option === "Migration" && <FPFormMigration />}
        {option === "Add template to FP Form" && <FpFormTemplateId/>}
      </Container>
    </>
  );
};

export default FPForms;
